import { apiCall } from "./apiClient";
import { ProductItem } from "../models/product/product";

export const getProducts = (
    signal: AbortSignal
) => {
    return apiCall<ProductItem[]>(
        "Products",
        "GET",
        null,
        signal
    );
};
